import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { free_trial } from '../../../Action/action';
import info from '../../../assets/images/info_icon.svg';
import { AnnouncementTexts } from './AnnouncementTexts';

export default function AnnouncementWidget() {
  const [announcementText, setAnnouncement] = useState(null);

  const dispatch = useDispatch();
  const subscriptionStatus = useSelector((state) => state.menuReducer.subscriptionStatus);
  const isEnterpriseUser = useSelector((state) => state.menuReducer.isEnterpriseUser);
  const product = useSelector((state) => state.menuReducer.enterpriseProduct);
  const plan = useSelector((state) => state.menuReducer.enterprisePlan);
  const profile = useSelector((state) => state.menuReducer.profile);
  const previousPayment = useSelector((state) => state.menuReducer.previousPayment);
  const showOn = ['INACTIVE', 'FAILED'];

  useEffect(() => {
    let announcement = !previousPayment
      ? AnnouncementTexts.FIRST_TIME
      : AnnouncementTexts.PAYMENT_FAILED;
    setAnnouncement(announcement);
  }, [previousPayment]);

  const showAnnouncement = () => {
    let permission;
    if (product === 'BUY') {
      permission = isEnterpriseUser && showOn.includes(subscriptionStatus);
    }
    if (product === 'INSIGHTS') {
      permission = isEnterpriseUser && plan === 'POC';
    }

    return permission;
  };

  return (
    <div className="announcement">
      {showAnnouncement() ? (
        <div className="announcement_container">
          <div className="announcement_left">
            <img src={info} />
            <div className="announcement_left_content">
              <span className="announcement_left_title">{announcementText?.title}</span>
              <span className="announcement_left_subtitle">
                Hi {profile && profile.firstName && profile.firstName},{' '}
                {announcementText?.subText}
              </span>
            </div>
          </div>
          <div className="announcement_right">
            <button
              onClick={() => dispatch(free_trial(true, product && product, plan && plan))}
              className="announcement_btn"
            >
              {announcementText?.btnText}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
